import { Component, OnInit, ViewEncapsulation, Input, Output, EventEmitter } from '@angular/core';
import { HttpServices } from '../../services/http.service';
import { PaymentCard, ListTypeCard } from '../../models';
import { Right } from '../../models/Rights.enum';

import { faCheckCircle, faTimes } from '@fortawesome/free-solid-svg-icons';
import { faCircle, faTrashAlt } from '@fortawesome/free-regular-svg-icons';
import { ReferenceService } from '../../services/reference.service';
import { CreditCardsService } from 'src/app/services/credit-cards.service';
import { LoaderService } from 'src/app/services/loader.service';

@Component({
  selector: 'fs-credit-cards',
  styleUrls: ['./credit-cards.sass'],
  templateUrl: './credit-cards.component.html',
  encapsulation: ViewEncapsulation.None
})

export class CreditCardsComponent implements OnInit {
  @Input() cardsList: PaymentCard[];
  @Input() supplier: number;
  @Input() pageName: string;
  @Input() selectedCardId: number;
  @Input() defaultCardId: number;
  @Output() clickCard: EventEmitter<any> = new EventEmitter();
  @Output() clickNewCard: EventEmitter<any> = new EventEmitter();
  @Output() clickRemoveCard: EventEmitter<any> = new EventEmitter();

  rights = Right;
  hasDefaultCard: boolean = false;
  listCards = new Array<PaymentCard>();
  ListTypeCard = ListTypeCard;

  faCheckCircle = faCheckCircle;
  faCircle = faCircle;
  faTrashAlt = faTrashAlt;
  faTimes = faTimes;

  constructor(public creditCardsService: CreditCardsService) { }

  ngOnInit() { }

  getTooltip(card: PaymentCard): string {
    let infoTooltip = 'Carte ';
    const cardExpired = this.creditCardsService.isExpiredCard(card);

    if (card.PaymentMethodCardId === this.selectedCardId) {
      infoTooltip += 'par défaut';
    }

    if (cardExpired) {
      infoTooltip += ' expirée';
    }

    if (infoTooltip === 'Carte ') {
      infoTooltip = 'Cliquez ici pour définir comme carte par défaut';
    }

    return infoTooltip;
  }

  onClickCard(card: PaymentCard, event: Event) {
    if (event.defaultPrevented || this.creditCardsService.isExpiredCard(card)) {
      return;
    }

    this.clickCard.emit({ 'supplierId': this.supplier, 'cardId': card.PaymentMethodCardId });
  }

  onRemoveCard(event: Event, cardId: number) {
    event.stopPropagation();

    if (event.defaultPrevented) {
      return;
    }

    this.clickRemoveCard.emit({ 'supplierId': this.supplier, 'cardId': cardId });
  }
}
